import type { GetStaticProps } from "next";
import type { ResourceCoreDataFragment } from "~/__generated__/graphql";
import { getSdk } from "~/__generated__/graphql";
import Metadata from "~/components/metadata";
import ResourcePage from "~/components/resource";
import client from "~/config/client";
export type ResourcesProps = {
  data: {
    resources: ResourceCoreDataFragment[];
  };
};
export const getStaticProps: GetStaticProps<ResourcesProps> = async () => {
  const sdk = getSdk(client);

  const { resourcePage } = await sdk.ResourcesContents();
  const { resources } = Object.assign({ resources: [] }, resourcePage?.data?.attributes);

  return {
    revalidate: 1,
    props: {
      data: {
        resources,
      },
    },
  };
};
export default function Resources({ data }: ResourcesProps) {
  return (
    <>
      <Metadata
        pageTitle="Advante Resources"
        title="Improve Your Performance with Our Coaching Resources"
        description="Our coaching resources are designed to provide you with the support you need to overcome obstacles and reach your full potential."
        canonical="https://advante.co/resources"
      />
      <ResourcePage data={data} />
    </>
  );
}
